import { toast } from "sonner";

const KEY = "ls_employee_preview";
const PREFIX = "ls_preview_pref:";
export function getPreview() {
  const raw = sessionStorage.getItem(KEY);
  if (raw === null) return null;
  const invalid = { preview_token: "invalid-preview", name: "Vorschau nicht verfügbar" };
  try {
    const value = JSON.parse(raw);
    return typeof value?.preview_token === "string" && value.preview_token.trim() ? value : invalid;
  } catch (_) { return invalid; }
}
export function setPreview(value) {
  clearPreviewPreferences();
  if (value) sessionStorage.setItem(KEY, JSON.stringify(value));
  else sessionStorage.removeItem(KEY);
}
function clearPreviewPreferences() {
  Object.keys(sessionStorage).filter(k => k.startsWith(PREFIX)).forEach(k => sessionStorage.removeItem(k));
}
export function simulateExternalAction() {
  toast.info("Vorschau: Diese Aktion wurde nur simuliert. Es wurde niemand kontaktiert.");
}
// Per-tab preferences/drafts; admin browser settings and real drafts remain untouched.
export const appStorage = {
  getItem(key) { return getPreview() ? sessionStorage.getItem(PREFIX + key) : localStorage.getItem(key); },
  setItem(key, value) { return getPreview() ? sessionStorage.setItem(PREFIX + key, value) : localStorage.setItem(key, value); },
  removeItem(key) { return getPreview() ? sessionStorage.removeItem(PREFIX + key) : localStorage.removeItem(key); },
};

if (typeof window !== "undefined") {
  document.addEventListener("click", event => {
    if (!getPreview()) return;
    const link = event.target.closest?.("a[href]");
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !["http:", "https:"].includes(url.protocol)) {
      event.preventDefault();
      simulateExternalAction();
    }
  }, true);
  const originalOpen = window.open;
  window.open = function(url, ...args) {
    if (getPreview()) { simulateExternalAction(); return null; }
    return originalOpen.call(window, url, ...args);
  };
}
